import { useCallback } from 'react'
import { PdfConfigTemplateSingleTy } from '../../types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { PdfConfigTemplateTabProps } from '../types'
import { addAntiUnsaveElement } from '../../../../../../../../utils/reducers/reduxDispatch'

interface ModalConfigPdfDeleteSectionProps extends ModalConfigPdfDeleteSectionLogicProps { }

const ModalConfigPdfDeleteSection: React.FC<ModalConfigPdfDeleteSectionProps> = ({ setOpenModal, ...rest }) => {
    const { removeSection } = useModalConfigPdfDeleteSectionLogic({ ...rest, setOpenModal })
    const { t } = useTwinTranslation()
    return (
        <ModalDeleteFilled opened={true} setOpened={() => setOpenModal(null)} onCancel={() => setOpenModal(null)} onAccept={removeSection} translations={{
            title: t('sureDeleteSection', '¿Seguro que quieres eliminar esta sección?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} className='modal_delete_section_pdf'/>
    )
}

interface ModalConfigPdfDeleteSectionLogicProps extends PdfConfigTemplateTabProps {
    myKey: number
}

const useModalConfigPdfDeleteSectionLogic = ({ setConfig, myKey }: ModalConfigPdfDeleteSectionLogicProps) => {
    const { t } = useTwinTranslation()
    const sectionName = t('section', 'Sección')
    const removeSection = useCallback(async () => {
        await addAntiUnsaveElement(['pdf_template_changes', '{}'])
        let myPageKey: number | null = null
        let mySectionKey: number  | null = null
        const splitKey = String(myKey).split(',')
        myPageKey = parseInt(splitKey[0])
        mySectionKey = parseInt(splitKey[1])
        if (myKey) {
            setConfig((old) => {
                const copy: PdfConfigTemplateSingleTy = JSON.parse(JSON.stringify(old))
                copy.pages[myPageKey!].sections.splice(mySectionKey!, 1)
                for (const element of copy.pages[myPageKey!].sections) {
                    element.name = sectionName + ' ' +(copy.pages[myPageKey!].sections.indexOf(element) + 1)
                }
                return { ...copy }
            })
        }

    }, [setConfig, myKey, sectionName])
    return { removeSection }
}

export default ModalConfigPdfDeleteSection